import useLang from "hooks/useLang";
import { useState } from "react";
import styles from "./Login.module.scss";
// import useApiCall from 'hooks/useApiCall';
import axios from "axios";

const LoginComponent = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { lang } = useLang();
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
  });

  // const { post } = useApiCall();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare the data to be sent to the backend
    const loginData = {
      username,
      password,
    };

    try {
      // Make API request to login
      const response = await client.post("/be/api/v1/login", loginData);
      const { token } = response.data;

      // Store token in localStorage or sessionStorage for further authentication
      localStorage.setItem("authToken", token);

      // Redirect or handle successful login
      alert("Login successful");
      // Optionally, redirect to admin dashboard
      window.location.href = '/admin/dashboard';
    } catch (error) {
      let errorMsg = error.message;
      if (error.response && error.response.data) {
        const { data } = error.response;
        errorMsg = data.message;
      }
      alert(errorMsg);
      setErrorMessage("Invalid username or password");
    }
  };
  return (
    <div className={styles["login-container"]}>
      <div className={styles["form-container"]}>
        <h2>{lang.admin.login.title}</h2>
        <form onSubmit={handleSubmit}>
          <label for="usename">Username:</label>
          <input
            type="username"
            id="username"
            name="username"
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <label for="password">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default LoginComponent;
